import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
// Los componentes de Vuetify (v-card, v-dialog, v-combobox...) no crean un validador propio. Si lo crean, se lo proveen
// a sus hijos y los inputs base (BaseCombobox, BaseInput, BaseDatePicker) que hacen inject de $validator quedan registrados
// en el validador del v-card y no en el del formulario: el formulario valida OK y los errores no se muestran.
// Tiene que registrarse antes que VeeValidate para correr antes que su beforeCreate.
Vue.mixin({
  beforeCreate() {
    const name = this.$options.name;
    if (name && /^v-/.test(name)) this.$options.$__veeInject = false;
  },
});
Vue.use(VeeValidate);
Validator.localize("es", es);

Validator.extend('combobox_required', {
    getMessage: field => 'Seleccione una opción del listado',
    validate: value => value && ( value.id != null || value.id != undefined || value.Id != null || value.Id != undefined)
});

Validator.extend('combobox', {
    getMessage: field => 'Seleccione una opción del listado',
    validate: value => (value && ( value.id >= 0 || value.Id >= 0 || value.id != null )) || value == null
});

export default VeeValidate;
